import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';

export const WidgetGroup = styled.div`
  margin-top: ${sizes.small};
`;

export const WidgetCategoryHeaderWrapper = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const WidgetCategoryHeader = styled(StandardTypography)`
  color: ${colors.gray4};
  font-size: ${fontSize.hint};
  text-transform: uppercase;
`;

export const ViewAllWrapper = styled.div`
  padding: ${sizes.xSmall} 0 0;
  border-top: 1px solid ${colors.gray2};
  text-align: center;
`;

export const ViewAll = styled.button`
  color: ${colors.blue4};
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
`;
